module.exports = __webpack_public_path__ + "img/telegram.f2d2e6d8.svg";